import { RenderIfRoutinesFFEnabled } from 'featureFlags';
import { Box, Show, Tooltip } from 'shared';
import { Flex, FlexItem } from 'shared_DEPRECATED/components/Flex';
import { HotjarSuppression } from 'shared_DEPRECATED/components/Hotjar';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import { Spacers } from 'shared_DEPRECATED/components/Spacer';

import {
  ChallengeInfoImage,
  ChallengeInfoName,
  ChallengeInfoPrivacy,
} from 'features/challenge/components/Info/';
import { ENTITY_TYPES } from 'features/challenge/config';
import {
  EntityType,
  RequireEmojiOrPicture,
} from 'features/challenge/config/types';

type TChallengeInfoProps = {
  title: string;
  children?: React.ReactNode;
  isPrivate?: boolean;
  isCropped?: boolean;
  maxWidth?: string;
  entityType?: EntityType;
} & RequireEmojiOrPicture;

export const ChallengeInfo = ({
  emoji,
  pictureFileUrl,
  pictureUrl,
  title,
  children,
  isPrivate,
  isCropped,
  maxWidth,
  entityType,
}: TChallengeInfoProps) => (
  <Flex>
    <FlexItem flexShrink={0}>
      <Spacers sizes={['zr md zr zr', 'zr sm zr zr']}>
        <Box position="relative" data-testid="text-absolute">
          <ChallengeInfoImage
            title={title}
            emoji={emoji}
            pictureUrl={pictureUrl}
            pictureFileUrl={pictureFileUrl || ''}
          />
          <RenderIfRoutinesFFEnabled>
            <Show when={entityType === ENTITY_TYPES.CHALLENGE}>
              <Tooltip
                content="Challenge"
                openDelay={0}
                closeDelay={0}
                positioning={{ offset: { mainAxis: 35 } }}
              >
                <Box
                  bg="var(--black)"
                  borderRadius="50%"
                  p="2px"
                  position="absolute"
                  right="-5px"
                  bottom="-5px"
                  cursor="default"
                >
                  <Icon name={iconNames.hiking} fill="var(--white)" />
                </Box>
              </Tooltip>
            </Show>
          </RenderIfRoutinesFFEnabled>
        </Box>
      </Spacers>
    </FlexItem>
    <HotjarSuppression>
      <Flex flexDirection="column" alignItems="start">
        <Flex gap="0.25rem">
          <ChallengeInfoName
            name={title}
            isCropped={isCropped}
            maxWidth={maxWidth}
          />
          <ChallengeInfoPrivacy isPrivate={isPrivate} />
        </Flex>
        {children}
      </Flex>
    </HotjarSuppression>
    <Spacers sizes={['zr sm zr']} />
  </Flex>
);
